import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from '../../environments/environment';
import { HttpClient, provideHttpClient } from '@angular/common/http';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { UIHelper } from './ui.helper';
import { APP_CONFIG } from './config/app-config.service';
import { CustomTranslateLoader } from './theme/custom-translate.loader';

// export function HttpLoaderFactory(http: HttpClient) { 
//   return new TranslateHttpLoader(
//     http,
//     `${environment.i18nPrefix}/assets/i18n/`,
//     '.json'
//   );
// }

export function HttpLoaderFactory(http: HttpClient) {
  return new CustomTranslateLoader(http);
}

export function initializeAppConfig() {
  return environment;
}


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
  ],
  providers: [  
    provideHttpClient(),
    {
      provide: APP_CONFIG,
      useFactory: initializeAppConfig,
    },
    UIHelper,
  ],
  exports: [TranslateModule]
})
export class NewCoreModule {
  constructor (
    @Optional()
    @SkipSelf()
    parentModule: NewCoreModule
  ) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only');
    }
  }
}
